import React from 'react'
import { Dialog, DialogContent, IconButton, Box } from '@mui/material'
import { useModalContext } from '../../contexts/ModalProvider'
import BacktestInput from '../../app/backtest/components/BacktestInput'
import CloseIcon from '@mui/icons-material/Close'

const BacktestRunDialog: React.FC = () => {
  const { isBacktestRunDialogOpen, setIsBacktestRunDialogOpen } = useModalContext()

  const handleClose = () => {
    setIsBacktestRunDialogOpen(false)
  }

  return (
    <Dialog
      open={isBacktestRunDialogOpen}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
      sx={{ zIndex: 1000 }}
    >
      <Box sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
        <IconButton onClick={handleClose} size="large">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0 }}>
        <BacktestInput />
      </DialogContent>
    </Dialog>
  )
}

export default BacktestRunDialog
